// @ts-check
import { defineConfig } from '../utils';

export function sideNavbar() {
  return defineConfig({
    properties: {
      'BarraNavegacionLateral.MostrarBarra': {
        defaultValue: true,
      },
      'BarraNavegacionLateral.MostrarPaletizado': {
        defaultValue: true,
      },
      'BarraNavegacionLateral.MostrarPaletizadoMultiple': {
        defaultValue: true,
      },
      'BarraNavegacionLateral.MostrarGestionarLineasProduccion': {
        defaultValue: true,
      },
      'BarraNavegacionLateral.MostrarEstadoPedidosProduccion': {
        defaultValue: true,
      },
      'BarraNavegacionLateral.MostrarGestionarSalidasProduccion': {
        defaultValue: true,
      },
      'BarraNavegacionLateral.OrdenElementos': {
        defaultValue: [
          'palletizing',
          'multiplePalletizing',
          'manageProductionLines',
          'productionOrdersStatus',
          'manageProductionOutputs',
        ],
      },
    },
  });
}
